import React, { Component, PropTypes } from 'react';

import ListContainer from './components/ListContainer';

class ItemsView extends Component {
  static propTypes = {
    isEditing: PropTypes.bool, // Can't make isRequired because prop is added in React.cloneElement() in App.js
    hideSelected: PropTypes.bool, // Can't make isRequired because prop is added in React.cloneElement() in App.js
    filter: PropTypes.string, // Can't make isRequired because prop is added in React.cloneElement() in App.js
    params: PropTypes.shape({
      list: PropTypes.string.isRequired
    }).isRequired
  }

  render() {
    const { isEditing, hideSelected, filter } = this.props;

    return (
      <ListContainer root={`/items/${this.props.params.list}`} {...{ isEditing, hideSelected, filter }} />
    );
  }
}

export default ItemsView;



/** WEBPACK FOOTER **
 ** ./src/ItemsView.js
 **/